import axios from "axios"
const URL = process.env.REACT_APP_MASTER_URL


export async function getAllIsobData() {
    console.log("inside getIsobData")
    const url = `${URL}/enquiry/sharepointlist/allisob`;
    console.log("inside getIsobData", url)
    let response = await axios.get(url);
    console.log("inside inside getIsobData", response.data)
    return response.data;
}

export async function getIsobData(isobObj) {
    console.log("inside getIsobData")
    const url = `${URL}/enquiry/sharepointlist/isob`;
    console.log("inside getIsobData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobData", response.data)
    return response.data;
}

export async function getIsobBpData(isobObj) {
    console.log("inside getIsobBpData")
    const url = `${URL}/enquiry/sharepointlist/isobBp`;
    console.log("inside getIsobBpData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobBpData", response.data)
    return response.data;
}

export async function getIsobPgCompData(isobObj) {
    console.log("inside getIsobPgCompData")
    const url = `${URL}/enquiry/sharepointlist/isobPgComp`;
    console.log("inside getIsobPgCompData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobPgCompData", response.data)
    return response.data;
}

export async function getIsobDwgData(isobObj) {
    console.log("inside getIsobDwgData")
    const url = `${URL}/enquiry/sharepointlist/isobDwg`;
    console.log("inside getIsobDwgData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobDwgData", response.data)
    return response.data;
}

export async function getIsobPgCommercialData(isobObj) {
    console.log("inside getIsobPgCommercialData")
    const url = `${URL}/enquiry/sharepointlist/isobPgCommercial`;
    console.log("inside getIsobPgCommercialData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobPgCommercialData", response.data)
    return response.data;
}

export async function getIsobPgStandardColorsData() {
    console.log("inside getIsobPgStandardColorsData")
    const url = `${URL}/enquiry/sharepointlist/isobPgStdColors`;
    console.log("inside getIsobPgData", url)
    let response = await axios.get(url);
    console.log("inside inside getIsobPgStandardColorsData", response.data)
    return response.data;
}

export async function getIsobDealerSacData(isobObj) {
    console.log("inside getIsobDealerSacData")
    const url = `${URL}/enquiry/sharepointlist/isobDealerSac`;
    console.log("inside getIsobDealerSacData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobDealerSacData", response.data)
    return response.data;
}

export async function getIsobAdvanceData(isobObj) {
    console.log("inside getIsobAdvanceData")
    const url = `${URL}/enquiry/sharepointlist/isobAdvance`;
    console.log("inside getIsobAdvanceData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobAdvanceData", response.data)
    return response.data;
}

export async function getIsobLdData(isobObj) {
    console.log("inside getIsobLdData")
    const url = `${URL}/enquiry/sharepointlist/isobLd`;
    console.log("inside getIsobLdData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobLdData", response.data)
    return response.data;
}

export async function getIsobMiscData(isobObj) {
    console.log("inside getIsobMiscData")
    const url = `${URL}/enquiry/sharepointlist/isobMisc`;
    console.log("inside getIsobMiscData", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getIsobMiscData", response.data)
    return response.data;
}

export async function getSalesManagerRole(isobObj) {
    console.log("inside getSalesManagerRole")
    const url = `${URL}/enquiry/sharepointlist/salesmanagerrole`;
    console.log("inside getSalesManagerRole", url)
    let response = await axios.post(url, isobObj);
    console.log("inside inside getSalesManagerRole", response.data)
    return response.data;
}